import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../lib/helpers';
import {EditContentStore} from '../../x7/content-parts/EditContentStore';
import {StaticImageModel} from './models';
import {staticImageEditStoreRenderer} from './static-image-edit-store-renderer';
import {StaticImageEditStore} from './StaticImageEditStore';

@observer
export class X9StaticImageEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: StaticImageEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore }>) {
    super(props);

    this.store = new StaticImageEditStore();
    const value = props.store.content.Contents;
    const model = JSON.parse(value) as StaticImageModel;
    this.store.sync(model);

    this.setup();
  }

  render() {
    return Array.from(staticImageEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
